import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { QueryGuidService } from './query-guid-service.template';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { getHttpHeader } from "../../utils/http-header.factory";

export class GetAllService<T> extends QueryGuidService<T> {
    
  constructor(url: string, http: HttpClient) {
    super(url, http);
  }

  public get({ tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<T>>{
    return this.http.get<ApiResponseModel<T>>(api_domain_url + this.apiUrl, getHttpHeader(jwt_secret, tenantCode));
  }
}
